import { ISODate } from '@framework/ui/components/date/ISODate.tsx';
import { FlexRow } from '@framework/ui/components/row/FlexRow.tsx';
import { VerticalSpace } from '@framework/ui/components/space/VerticalSpace.tsx';
import { Divider, Space, Tag } from 'antd';
import type * as React from 'react';
import { useTheme } from 'styled-components';
import { CommunicationSubject } from './CommunicationSubject.tsx';

export interface ICommunicationCollapseHeaderProps {
  date?: string | Date | null | undefined;
  isDraft?: boolean;
  isManual?: boolean;
  format?: string;
  subject?: string | null;
  protocol?: React.ReactNode;
  /** Stato di lettura del destinatario corrente */
  readState?: React.ReactNode;
  actors?: React.ReactNode;
  actions?: React.ReactNode;
}

/**
 * Singola comunicazione header per il collapse (sempre visibile)
 */
export function CommunicationCollapseHeader(
  props: ICommunicationCollapseHeaderProps,
) {
  const {
    date,
    isDraft,
    isManual,
    format,
    subject,
    readState,
    actors,
    actions,
    protocol,
  } = props;
  const theme = useTheme();

  return (
    <FlexRow responsive right={actions ?? undefined}>
      <div>
        <Space
          size={[4, 0]}
          split={date ? <Divider type="vertical" /> : undefined}
          wrap
        >
          <Space size={[0, 0]} wrap>
            {!isDraft ? (
              <Tag color="blue">INVIATA</Tag>
            ) : (
              <Tag color={theme.colorSuccess}>BOZZA</Tag>
            )}
            {isManual && <Tag color="red">MANUALE</Tag>}
            {readState}
            {date && (
              <ISODate format={format ?? 'DD/MM/YYYY HH:mm'} date={date} />
            )}
          </Space>
          {protocol}
        </Space>
        <div>
          <VerticalSpace size={3} />
          <CommunicationSubject subject={subject} />
        </div>
        <div>{actors}</div>
      </div>
    </FlexRow>
  );
}
